export default "__VITE_ASSET__Bq_NN3cu__"